import { ElMessage } from 'element-plus'
import { router } from '@/router'
const ERROR_CODE_TABLE = {
    '10005': codeFunc10005
}

function codeFunc10005(){
    router.push('/404')
}
function makeErrorHandle404(errorCode){
    ERROR_CODE_TABLE[errorCode]()
}

export {makeErrorHandle404}